import { render, staticRenderFns } from "./ProductUserReviewSection.vue?vue&type=template&id=a79a4528&scoped=true&"
import script from "./ProductUserReviewSection.vue?vue&type=script&lang=js&"
export * from "./ProductUserReviewSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductUserReviewSection.vue?vue&type=style&index=0&id=a79a4528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79a4528",
  null
  
)

export default component.exports